// import * as types from '@/store/mutation-types'
export default {
    namespaced: true,

    state: {
        tripId: null,
        tripType: null
    },
    actions: {
        // new driverAssistant trip lifecycle - bus/assistant identity comes from the JWT, no centerId/userName needed
        startTrip ({ commit }, { tripType }) {
            return window.coreAxios.post('/driverAssistant/trips/start', { tripType }).then(({ data }) => {
                commit('SET_TRIP_ID', data.data)
                commit('SET_TRIP_TYPE', tripType)
                localStorage.setItem('tripId', data.data)
                localStorage.setItem('tripType', tripType)
                return data.data
            })
        },

        endActiveTrip ({ commit }, { tripId }) {
            return window.coreAxios.post(`/driverAssistant/trips/${tripId}/end`).then(() => {
                commit('SET_TRIP_ID', null)
                commit('SET_TRIP_TYPE', null)
                localStorage.removeItem('tripId')
                localStorage.removeItem('tripType')
            })
        },

        fetchTrip ({ commit }, { tripId }) {
            return window.coreAxios.get(`/driverAssistant/trips/${tripId}`).then(({ data }) => data.data)
        },

        fetchTripStudents ({ commit }, { tripId }) {
            return window.coreAxios.get(`/driverAssistant/trips/${tripId}/students`).then(({ data }) => data.data)
        },

        markAttendance ({ commit }, { tripId, studentId, status }) {
            return window.coreAxios.post(`/driverAssistant/trips/${tripId}/students/${studentId}/attendance`, { status })
        },

        dropoffStudent ({ commit }, { tripId, studentId }) {
            return window.coreAxios.post(`/driverAssistant/trips/${tripId}/students/${studentId}/dropoff`)
        },

        notifySchoolArrival ({ commit }, { tripId }) {
            return window.coreAxios.post(`/driverAssistant/trips/${tripId}/notifySchoolArrival`)
        },

        notifyApproaching ({ commit }, { tripId, studentId }) {
            return window.coreAxios.post(`/driverAssistant/trips/${tripId}/students/${studentId}/notifyApproaching`)
        },

        // live GPS ping - call periodically while the trip is active, feeds the student app's gpsTracking read
        sendCoordinates ({ commit }, { tripId, lat, lng }) {
            return window.coreAxios.post(`/driverAssistant/trips/${tripId}/coordinates`, { lat, lng })
        },

        hydrateTripId ({ commit }) {
            const tripType = localStorage.getItem('tripType')
            commit('SET_TRIP_ID', localStorage.getItem('tripId') || null)
            commit('SET_TRIP_TYPE', tripType === null ? null : Number(tripType))
        },

        // picks up a trip the bus already has running (profile.tripId) - remembers it locally
        // and resolves its direction, since profile doesn't say whether it's outbound or return
        resumeTrip ({ commit, dispatch }, { tripId }) {
            commit('SET_TRIP_ID', tripId)
            localStorage.setItem('tripId', tripId)

            return dispatch('fetchTrip', { tripId }).then((data) => {
                const tripType = data.trip?.tripType
                if (tripType === undefined || tripType === null) return null
                commit('SET_TRIP_TYPE', tripType)
                localStorage.setItem('tripType', tripType)
                return tripType
            }).catch(() => null)
        },

        // drops a locally-remembered trip without calling the API - for when the server
        // has already told us (via profile) that no trip is running
        clearTripId ({ commit }) {
            commit('SET_TRIP_ID', null)
            commit('SET_TRIP_TYPE', null)
            localStorage.removeItem('tripId')
            localStorage.removeItem('tripType')
        },

        startOrEndTransport ({ commit }, { centerId, userName, busId }) {
            return window.axios.get(`/center/${centerId}/assistant/${userName}/start`, { params: { busId } }).then(data => {
                return data
            })
        },

        studentAttend ({ commit }, { centerId, userName, accountId, status, fromSchool }) {
            return window.axios.post(`/center/${centerId}/assistant/${userName}/student-attend`, {}, {
                params: {
                    accountId,
                    status,
                    fromSchool
                }
            }).then(data => {
                return data
            })
        },

        endTrip ({ commit }, { centerId, userName, accountIds }) {
            return window.axios.post(`/center/${centerId}/assistant/${userName}/at-school`, accountIds).then(data => {
                return data
            })
        },

        endTripToHome ({ commit }, { centerId, userName, accountId }) {
            return window.axios.post(`/center/${centerId}/assistant/${userName}/getting-home`, {}, { params: { accountId } }).then(data => {
                return data
            })
        },

        updateNearHome ({ commit }, { centerId, userName, accountId }) {
            return window.axios.post(`/center/${centerId}/assistant/${userName}/bus-near-home`, accountId, { headers: { 'Content-Type': 'application/json' } }).then((data) => {
                return data
            })
        },

        sendBusCoordinates ({ commit }, { centerId, userName, busId, lng, lat }) {
            return window.axios.post(`center/${centerId}/assistant/${userName}/bus-coordinates`, {}, { params: { busId, lng, lat } }).then(({ data }) => {
                return data
            })
        },

        busStop ({ commit }, { centerId, userName, busId }) {
            return window.axios.post(`center/${centerId}/assistant/${userName}/bus-stop`, {}, { params: { busId } }).then(({ data }) => {
                return data
            })
        }
    },

    mutations: {
        SET_TRIP_ID (state, tripId) {
            state.tripId = tripId
        },

        SET_TRIP_TYPE (state, tripType) {
            state.tripType = tripType
        }
    },

    getters: {}
}
